__turbopack_context__.v({
  "close": "pill-module-scss-module__sGQLGG__close",
  "pill": "pill-module-scss-module__sGQLGG__pill",
  "wrapper": "pill-module-scss-module__sGQLGG__wrapper",
});
